/*
 * @description: 时间过滤器
 * @author: zb
 * @update: zb
 * @LastEditors: zb
 * @Date: 2019-04-24 20:05:06
 * @LastEditTime: 2019-05-16 13:37:16
 */

'use strict'

import * as moment from 'moment'

/**
 * 基于 moment 日期格式化，显示更多细节参考：
 *
 * @see http://momentjs.com/docs/#/displaying
 *
 * @example
 * ```html
 * {{ data | _data }}
 * 2017-09-17 15:35
 *
 * {{ data | _data: 'YYYY年MM月DD日' }}
 * 2017年09月17
 * ```
 */
const formatTime = (value, formatString) => {
  formatString ? '' : formatString = 'YYYY-MM-DD HH:mm'
  if (value) {
    return moment(value).format(formatString)
  } else {
    return value
  }
}

export { formatTime }

